import { render, staticRenderFns } from "./SampleReceiveNest.vue?vue&type=template&id=11f93e08"
import script from "./SampleReceiveNest.vue?vue&type=script&lang=js"
export * from "./SampleReceiveNest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports